export default __webpack_public_path__ + "images/564bdfe739febbaa4a007ea73eb977a4.svg";